export default "__VITE_ASSET__vpstHzvC__"